/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Title_OptionalInputs */

const en_mobile_title_optional = /** @type {(inputs: Mobile_Title_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title (optional)`)
};

const es_mobile_title_optional = /** @type {(inputs: Mobile_Title_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título (opcional)`)
};

/**
* | output |
* | --- |
* | "Title (optional)" |
*
* @param {Mobile_Title_OptionalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_title_optional = /** @type {((inputs?: Mobile_Title_OptionalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Title_OptionalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_title_optional(inputs)
	return en_mobile_title_optional(inputs)
});